module.exports = __webpack_public_path__ + "assets/img/477227638c96ad15ed1b0e8293efa1e3.png";